<div class="time-picker" [ngClass]="{ 'hidden': hidden, 'animate': animation }" (click)="onClickOutside($event)"  >
  <div class="time-picker__content" [ngClass]="{ 'animate': animation }">
    <div class="time-picker__wrapper">
      <section class="time-picker__time_holder">
        <span class="time-picker__time_h" [ngClass]="{ 'active': hourSectionActive && !minuteSectionActive }" (click)="onClickTimeActive()">
          {{ selectHour < 10 ? '0' + selectHour : selectHour}}
        </span>
        <span class="time-picker__timedots">:</span>
        <span class="time-picker__time_m" [ngClass]="{ 'active': !hourSectionActive && minuteSectionActive }" (click)="onClickTimeActive()">
          {{ selectMinute < 10 ? '0' + selectMinute : selectMinute }}
        </span>
        <span class="time-picker__ampm">
          <span class="time-picker__am" [ngClass]="{ 'active': amActive && !pmActive }" (click)="onClickAmPmActive()">AM</span>
          <span class="time-picker__pm" [ngClass]="{ 'active': !amActive && pmActive }" (click)="onClickAmPmActive()">PM</span>
        </span>
      </section>
      <section class="time-picker__clock_holder">
        <div class="time-picker__clock">
          <span class="time-picker__clock_dot"></span>
          <div class="time-picker__hour_holder" [ngClass]="getClassHourHolder()">
            <ng-container *ngFor="let hour of [].constructor(12); let i = index">
              <div class="time-picker__digit" [ngClass]="getClassHoursRotate(i)">
                <span (click)="onClickHour(i + 1)">{{ i + 1 }}</span>
              </div>
            </ng-container>
          </div>
          <div class="time-picker__minute_holder" [ngClass]="getClassMinuteHolder()">
            <ng-container *ngFor="let hour of [].constructor(60); let i = index">
              <div class="time-picker__digit" [ngClass]="getClassMinutesRotate(i)">
                <span (click)="onClickMinute(i)" *ngIf="i % 5 === 0; else emptyMinute">{{ i < 10 ? '0' + i : i }}</span>
                <ng-template #emptyMinute>
                  <span (click)="onClickMinute(i)"></span>
                </ng-template>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="time-picker__buttons">
          <button type="button" class="time-picker__button time-picker__accept" (click)="onClickAccept()">Aceptar</button>
          <button type="button" class="time-picker__button time-picker__cancel" (click)="onClickClosed()">Cancelar</button>
        </div>
      </section>
    </div>
  </div>
</div>